import { render, staticRenderFns } from "./WeightTrackingList.vue?vue&type=template&id=b4732fae&scoped=true&"
import script from "./WeightTrackingList.vue?vue&type=script&lang=js&"
export * from "./WeightTrackingList.vue?vue&type=script&lang=js&"
import style0 from "./WeightTrackingList.vue?vue&type=style&index=0&id=b4732fae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4732fae",
  null
  
)

export default component.exports